import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class F8865SchdK1Service {

  constructor(private http: HttpClient) { }

  /**
   * Build HTTP params for GET requests (matching AngularJS JsonObjectFactory.getJSONObj)
   * AngularJS uses $http.get(_url, {params: params}) which sends params as query string
   */
  private buildHttpParams(params: any): HttpParams {
    let httpParams = new HttpParams();
    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        const value = params[key];
        if (value !== null && value !== undefined) {
          httpParams = httpParams.set(key, 
            typeof value === 'object' ? JSON.stringify(value) : String(value)
          );
        }
      }
    }
    return httpParams;
  }

  /**
   * Build form data for POST requests (for save operations)
   */
  private buildFormData(params: any): string {
    const formData: string[] = [];
    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        const value = params[key];
        if (value !== null && value !== undefined) {
          formData.push(encodeURIComponent(key) + '=' + encodeURIComponent(
            typeof value === 'object' ? JSON.stringify(value) : value
          ));
        }
      }
    }
    return formData.join('&');
  }

  /**
   * Get POST HTTP options
   */
  private getPostHttpOptions() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      }),
      withCredentials: true
    };
  }

  /**
   * Load Schedule K WPD Detail for K1 Popup
   * Action code: 0mbkyx
   * Original: JsonObjectFactory.getJSONObj uses GET
   */
  getF8865SchdKWPDDetailForK1Popup(
    baseUrl: string,
    params: any,
    globalService: any,
    filterParams?: any
  ): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    
    // Merge params like AngularJS does
    const mergedParams = {
      ...globalService,
      ...(filterParams || {}),
      action_code: '0mbkyx',
      tax_year: params.tax_year,
      scenario: params.scenario,
      jcd_key: params.jcd_key,
      combination_key: params.combination_key
    };

    return this.http.get(url, { 
      params: this.buildHttpParams(mergedParams),
      withCredentials: true
    });
  }

  /**
   * Load Schedule K1 WPD Detail for Entity
   * Action code: dr530x
   * Original: JsonObjectFactory.getJSONObj uses GET
   */
  getF8865SchdK1WPDDetailForEntity(
    baseUrl: string,
    params: any,
    globalService: any,
    filterParams?: any
  ): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    
    const mergedParams = {
      ...globalService,
      ...(filterParams || {}),
      action_code: 'dr530x',
      tax_year: params.tax_year,
      scenario: params.scenario,
      jcd_key: params.jcd_key,
      combination_key: params.combination_key
    };

    return this.http.get(url, { 
      params: this.buildHttpParams(mergedParams),
      withCredentials: true
    });
  }

  /**
   * Save Schedule K1 WPD for Entity
   * Action code: fl4p7n
   */
  save8865SchdK1WPDForEntity(
    baseUrl: string,
    clobSettings: any,
    clobData: any[],
    globalService: any,
    filterParams: any
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=fl4p7n`;
    
    let params = _.merge({}, globalService || {}, filterParams || {});
    
    // Add complex JSON fields (extends params object)
    params = _.extend({ clob_data: JSON.stringify(clobData) }, params);
    params = _.extend({ clob_settings: JSON.stringify(clobSettings) }, params);
    
    // Override ONLY specific fields that AngularJS explicitly overrides (lines 46-50)
    // Only override if value exists (don't set to undefined)
    if (filterParams?.tax_year !== undefined) {
      params.tax_year = filterParams.tax_year;
    }
    if (filterParams?.scenario !== undefined) {
      params.scenario = filterParams.scenario;
    }
    if (globalService?.jcd_key !== undefined) {
      params.jcd_key = globalService.jcd_key;
    }
    params.process_name = 'Save F8865 Schd-K1 WPD for Entity';
    if (clobSettings?.sso_id !== undefined) {
      params.sso_id = clobSettings.sso_id;
    }
    
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}
